export default class Event {
  id = 0;

  title = '';

  description = '';

  price = 0;

  basePrice = 0;

  allowSingleSessionPurchase = false;

  allowWaitlist = false;

  allowStaffSelection = false;

  spotsRemaining = 0;

  enableDynamicPricing = false;

  singleSessionPrice = 0;

  participantCount = 0;

  privacy = false;

  url = '';

  path = '';

  adminPath = '';

  status = '';

  //   Image: Image;
  //   ImageDimensions: Image;
  //   EventType: EventType;
  //   PurchasedRegistrations: Registration[];
  //   Registrations: Registration[];
  sessionIds = [''];

  scheduleType = '';

  //   Schedules: Schedule[];
  //   ExclusiveMembershipIds: Array<number[]>;
  productType = '';
}
